import { appealStatusSelectOptions } from 'KnmErknmPackage/MainModule/constants/appealStatusSelectOptions';

import { RenderFunc } from '../types/RenderFunc';

export const renderAppealStatus: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue:
      appealStatusSelectOptions.find(option => option.value === oldValue)?.label ||
      appealStatusSelectOptions.find(option => option.label === oldValue)?.label ||
      '',
    renderedNewValue:
      appealStatusSelectOptions.find(option => option.value === newValue)?.label ||
      appealStatusSelectOptions.find(option => option.label === oldValue)?.label ||
      '',
  };
};
